﻿$(function () {

    $('html').removeClass('no-js');

    $('.imgfill').each(function () {
        $(this).imagefill();
    });

    /* Toggle the mobile menu */
    $('.header-menu-toggle').click(function () {
        $('body').toggleClass('show-menu');
    });
    $('.mobile-nav-bottom .sign-up.open-sign-up-modal').click(function () {
        $('body').toggleClass('show-menu');
    });
    /* Toggle the visiblity of the map on the search page */
    $('.search-map-toggle').live('click', function (e) {
        e.preventDefault();
        if (typeof (loadTheMap) != 'function') return false;

        loadTheMap();

        var $container = $('#map-application');
        var $header = $('.search-header');
        var isVisible = parseInt($container.css('height')) > 0;
        if (!isVisible) {
            $container.animate({ height: 600, zIndex: 10 }, 600);
            $header.slideUp(600);
            $('html,body').animate({
                scrollTop: $('.search-header').offset().top
            }, 600);

            $(this).text('Hide the map');
        } else {
            $container.animate({ height: 0, zIndex: 0 }, 600);
            $header.slideDown(600);
            $(this).text('Map');
        }
        return false;
    });

   
    /*HOME Locations list */

    $('.where-to-go-list h3').click(function (e) {
        if ($(window).width() <= 480) {
            e.preventDefault();
            $(this).siblings('ul').slideToggle();
        }
    });

    $('.where-to-go-list a').mouseover(function () {
        var point = { lat: parseFloat($(this).data('lat')).toFixed(3), lng: parseFloat($(this).data('lng')).toFixed(3) };
        var sw = { lat: 49.930892, lng: -5.8255 };
        var ne = { lat: 50.692978, lng: -4.316254 };

        point.lat = Math.min(point.lat, ne.lat);
        point.lat = Math.max(point.lat, sw.lat);

        point.lng = Math.min(point.lng, ne.lng);
        point.lng = Math.max(point.lng, sw.lng);

        var range = { lat: Math.abs(ne.lat - sw.lat), lng: Math.abs(ne.lng - sw.lng) }
        var offset = { lat: Math.abs(ne.lat - point.lat), lng: Math.abs(ne.lng - point.lng) };
        var dims = { x: Math.min($(window).width(), 918), y: Math.min($(window).height(), 726) };
        var pxPerDeg = { y: dims.y / range.lat, x: dims.x / range.lng };
        var pos = { top: pxPerDeg.y * offset.lat, right: pxPerDeg.x * offset.lng };

        if ($('.where-to-go-dot').length == 0) {
            $('<div>').addClass('where-to-go-dot').appendTo('.where-to-go');
        }
        $('.where-to-go-dot').css('opacity', !isNaN(point.lat) ? 1 : 0);
        if (!isNaN(point.lat)) {
            $('.where-to-go-dot').stop().animate(pos, 100);
        }
    });

    $('.showMore').click(function (e) {
        e.stopPropagation();

        $('.showMoreContainer').toggleClass('showMoreExpanded');

    });

    $('.login-click').click(function (e) {
        if ($('.login-menu').hasClass('hidden')) {
            $('.login-menu').removeClass("hidden");
        } else {
            $('.login-menu').addClass("hidden");
        }

    });     

});
